type Any = Record<string, any>;
const root = document.querySelector<HTMLDivElement>("#app")!,
  toastEl = document.querySelector<HTMLDivElement>("#toast")!;
const state: Any = {
  user: null,
  csrf: "",
  route: location.pathname,
  catalog: null,
  board: null,
  filters: { q: "", assignee: "", priority: "" },
  mobileStage: "",
  timer: null,
  cardOpenSeq: 0,
};
const esc = (v: any) =>
  String(v ?? "").replace(
    /[&<>'"]/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[
        c
      ]!,
  );
const icon = (name: string) =>
  (
    ({
      home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="m3 11 9-8 9 8v9H3z"/></svg>',
      board:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="4" width="6" height="16"/><rect x="10" y="4" width="5" height="11"/><rect x="16" y="4" width="5" height="14"/></svg>',
      clients:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="9" cy="8" r="4"/><path d="M2 21c0-5 3-7 7-7s7 2 7 7M16 4c4 0 6 5 3 8m-2 3c3 1 5 3 5 6"/></svg>',
      time: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="9"/><path d="M12 7v6l4 2"/></svg>',
      team: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="8" cy="8" r="3"/><circle cx="17" cy="9" r="3"/><path d="M2 21c0-4 2-7 6-7s6 3 6 7m0-5c5-2 8 1 8 5"/></svg>',
      settings:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="3"/><path d="M19 14a7 7 0 0 0 0-4l2-2-3-4-3 1a7 7 0 0 0-4 0L8 3 4 6l1 3a7 7 0 0 0 0 4l-2 2 3 4 3-1a7 7 0 0 0 4 0l3 2 4-3z"/></svg>',
      bell: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/></svg>',
    }) as Any
  )[name] || "";
const fmtDate = (v: string) =>
  v
    ? new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "short",
        timeZone: "UTC",
      }).format(new Date(v + (/T/.test(v) ? "" : "T12:00:00Z")))
    : "Sem prazo";
const fmtTime = (s: number) =>
  `${Math.floor((s || 0) / 3600)}h ${Math.floor(((s || 0) % 3600) / 60)}min`;
const initials = (name: string) =>
  (name || "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((x) => x[0])
    .join("")
    .toUpperCase();
function notify(message: string, error = false) {
  toastEl.textContent = message;
  toastEl.className = `toast show${error ? " error" : ""}`;
  setTimeout(() => (toastEl.className = "toast"), 3000);
}
async function api(path: string, options: RequestInit = {}) {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof Blob)) {
    headers.set("Content-Type", "application/json");
  }
  if (state.csrf) headers.set("X-CSRF-Token", state.csrf);
  const response = await fetch(path, { ...options, headers });
  let data: any = {};
  if ((response.headers.get("content-type") || "").includes("json"))
    data = await response.json();
  if (!response.ok) {
    const err: any = new Error(data.error || "REQUEST_FAILED");
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
}
function navigate(path: string) {
  history.pushState({}, "", path);
  state.route = path;
  render();
}
addEventListener("popstate", () => {
  state.route = location.pathname;
  render();
});
function navItem(path: string, label: string, name: string) {
  return `<a href="${path}" data-nav class="${state.route === path || state.route.startsWith(path + "/") ? "active" : ""}">${icon(name)}<span>${label}</span></a>`;
}
function shell(title: string, content: string, actions = "") {
  return `<div class="shell"><aside class="sidebar"><div class="logo">ConnexLab <em>OS</em></div><nav class="nav">${navItem("/", "Dashboard", "home")}${navItem("/boards", "Boards", "board")}${navItem("/clientes", "Clientes", "clients")}${navItem("/timesheet", "Timesheet", "time")}${navItem("/equipe", "Equipe", "team")}${navItem("/configuracoes", "Configurações", "settings")}</nav><div class="profile"><span class="avatar">${initials(state.user.name)}</span><div><strong>${esc(state.user.name)}</strong><small>${esc(state.user.role)}</small></div></div></aside><main class="main"><header class="topbar"><h1>${esc(title)}</h1><div class="actions"><span id="active-timer"></span>${actions}<button class="button icon-button notification-button" id="notifications-button" aria-label="Notificações" aria-expanded="false">${icon("bell")}<span id="notification-badge" class="notification-badge" hidden></span></button></div><div id="notification-panel"></div></header><section id="main" class="content">${content}</section></main><nav class="mobile-nav">${navItem("/", "Home", "home")}${navItem("/boards", "Boards", "board")}${navItem("/clientes", "Clientes", "clients")}${navItem("/timesheet", "Mais", "time")}</nav></div>`;
}

async function bindNotifications(){
  const button=document.querySelector<HTMLButtonElement>("#notifications-button"); if(!button)return;
  const d=await api("/api/notifications"), badge=document.querySelector<HTMLElement>("#notification-badge")!;
  if(d.unread){badge.hidden=false;badge.textContent=d.unread>99?"99+":String(d.unread);}
  button.addEventListener("click",()=>{const host=document.querySelector<HTMLElement>("#notification-panel")!;if(host.innerHTML){host.innerHTML="";button.setAttribute("aria-expanded","false");return;} button.setAttribute("aria-expanded","true");const labels:Any={DUE_TOMORROW:"Prazo amanhã",DUE_TODAY:"Vence hoje",OVERDUE:"Atrasado"};host.innerHTML=`<aside class="notification-panel" role="dialog" aria-label="Notificações"><header><strong>Notificações</strong><button class="button ghost" id="read-all">Marcar todas como lidas</button></header><div>${d.notifications.length?d.notifications.map((n:Any)=>`<article class="notification-item ${n.read_at?"":"unread"}"><span class="pill">${labels[n.type]}</span><strong>${esc(n.title)}</strong><small>${esc(n.human_id)} · ${esc(n.client_name)} · ${fmtDate(n.due_date)}</small><small>Gerada em ${new Date(n.created_at).toLocaleString("pt-BR")}</small><button class="button" data-notification="${n.id}" data-board="${n.board_id}" data-open-card="${n.card_id}">Abrir card</button></article>`).join(""):'<div class="empty">Nenhuma notificação.</div>'}</div></aside>`;document.querySelector("#read-all")?.addEventListener("click",async()=>{await api("/api/notifications/read-all",{method:"POST",body:"{}"});host.innerHTML="";badge.hidden=true;});document.querySelectorAll("[data-notification]").forEach(el=>el.addEventListener("click",async()=>{const x=el as HTMLElement;await api(`/api/notifications/${x.dataset.notification}/read`,{method:"POST",body:"{}"});navigate(`/boards/${x.dataset.board}?card=${x.dataset.openCard}`);}));});
}
async function login() {
  root.innerHTML = `<main class="login"><section class="login-brand"><div class="logo">ConnexLab <em>OS</em></div><h1>A operação em um só <span>ritmo.</span></h1><p class="muted">Workspace interno · Ambiente DEV</p></section><section class="login-form"><div class="login-card"><span class="eyebrow">Acesso interno</span><h2>Bem-vindo de volta</h2><p class="muted">Entre com sua conta ConnexLab.</p><form id="login"><div class="field"><label for="email">E-mail</label><input class="input" id="email" name="email" type="email" autocomplete="username" required></div><div class="field"><label for="password">Senha</label><input class="input" id="password" name="password" type="password" autocomplete="current-password" minlength="12" required></div><div class="error" id="login-error"></div><button class="button primary" type="submit">Entrar</button></form></div></section></main>`;
  document.querySelector("#login")!.addEventListener("submit", async (e) => {
    e.preventDefault();
    const fd = new FormData(e.target as HTMLFormElement),
      button = (e.target as HTMLFormElement).querySelector("button")!;
    button.disabled = true;
    try {
      const data = await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify(Object.fromEntries(fd)),
      });
      state.user = data.user;
      state.csrf = data.csrf;
      render();
    } catch {
      document.querySelector("#login-error")!.textContent =
        "E-mail ou senha inválidos.";
    } finally {
      button.disabled = false;
    }
  });
}
async function dashboard() {
  const d = await api("/api/dashboard"),
    m = d.metrics;
  const metric = (label: string, value: any, alert = false) =>
    `<article class="metric ${alert ? "alert" : ""}"><span>${label}</span><strong>${value}</strong></article>`;
  const content = `<div class="metric-grid">${metric("Cards abertos", m.open)}${metric("Atrasados", m.overdue, true)}${metric("Vencem hoje", m.dueToday)}${metric("In progress", m.inProgress)}${metric("Internal review", m.internalReview)}${metric("External review", m.externalReview)}${metric("Ready to schedule", m.ready)}${metric("Done no mês", m.doneMonth)}</div><div class="metric-grid" style="margin-top:12px">${metric("Horas hoje", fmtTime(m.timeToday))}${metric("Horas no mês", fmtTime(m.timeMonth))}</div><div class="section-head"><div><span class="eyebrow">Foco</span><h2>Precisa da sua atenção</h2></div></div><div class="panel">${d.attention.length ? d.attention.map((c: Any) => `<a class="attention-row" href="/boards" data-nav><span class="pill danger">${c.due_date === new Date().toISOString().slice(0, 10) ? "Hoje" : "Atrasado"}</span><div><strong>${esc(c.human_id)} · ${esc(c.title)}</strong><small class="muted">${esc(c.client_name)} · ${esc(c.stage_name)}</small></div><span>${fmtDate(c.due_date)}</span></a>`).join("") : `<div class="empty"><strong>Tudo em dia</strong>Nenhum prazo crítico agora.</div>`}</div><div class="section-head"><div><span class="eyebrow">Clientes</span><h2>Visão operacional</h2></div><a href="/clientes" data-nav class="muted">Ver todos →</a></div><div class="panel">${d.clients.map((c: Any) => `<a href="/clientes/${c.id}" data-nav class="client-row"><div><strong>${esc(c.name)}</strong><small>Cliente ativo</small></div><div><strong>${c.active}</strong><small>abertos</small></div><div><strong>${c.overdue}</strong><small>atrasados</small></div><div><strong>${c.external_review}</strong><small>external review</small></div><div><strong>${fmtTime(c.month_seconds)}</strong><small>no mês</small></div><span>→</span></a>`).join("")}</div>`;
  root.innerHTML = shell(
    "Dashboard",
    content,
    `<button class="button primary" data-new-card><span>+ Novo card</span></button>`,
  );
}
async function clients() {
  const d = await api("/api/clients");
  const content = `<div class="section-head" style="margin-top:0"><div><span class="eyebrow">Carteira</span><h2>${d.clients.length} clientes</h2></div></div><div class="panel">${d.clients.length ? d.clients.map((c: Any) => `<div class="client-row"><a href="/boards/${c.id}" data-client-board><strong>${esc(c.name)}</strong><small>${esc(c.card_prefix)} · ${esc(c.status)}</small></a><div><strong>${c.boards}</strong><small>boards</small></div><div><strong>${c.cards}</strong><small>cards</small></div><div><strong>${c.overdue}</strong><small>atrasados</small></div><div></div><span>→</span></div>`).join("") : `<div class="empty"><strong>Nenhum cliente cadastrado</strong>Crie o primeiro cliente para iniciar a operação.</div>`}</div>`;
  root.innerHTML = shell(
    "Clientes",
    content,
    state.user.role === "ADMIN"
      ? `<button class="button primary" id="new-client">+ Novo cliente</button>`
      : "",
  );
  document.querySelector("#new-client")?.addEventListener("click", newClient);
  document.querySelectorAll("[data-client-board]").forEach((a) =>
    a.addEventListener("click", async (e) => {
      e.preventDefault();
      const boards = await api("/api/boards"),
        id = (a.getAttribute("href") || "").split("/").pop(),
        board = boards.boards.find((b: Any) => b.client_id === id);
      if (board) navigate("/boards/" + board.id);
    }),
  );
}
function modal(
  title: string,
  body: string,
  onSubmit: (data: Any, form: HTMLFormElement) => Promise<void>,
) {
  const wrap = document.createElement("div");
  wrap.className = "modal-backdrop";
  wrap.innerHTML = `<form class="modal"><h2>${esc(title)}</h2>${body}<div class="modal-actions"><button type="button" class="button" data-cancel>Cancelar</button><button class="button primary" type="submit">Salvar</button></div></form>`;
  document.body.append(wrap);
  wrap
    .querySelector("[data-cancel]")!
    .addEventListener("click", () => wrap.remove());
  wrap.addEventListener("click", (e) => {
    if (e.target === wrap) wrap.remove();
  });
  wrap.querySelector("form")!.addEventListener("submit", async (e) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement,
      button = form.querySelector<HTMLButtonElement>("button[type=submit]")!;
    button.disabled = true;
    try {
      await onSubmit(Object.fromEntries(new FormData(form)), form);
      wrap.remove();
    } catch (err: any) {
      notify(message(err), true);
      button.disabled = false;
    }
  });
  (wrap.querySelector("input") as HTMLElement)?.focus();
}
function newClient() {
  modal(
    "Novo cliente",
    `<div class="form-grid"><div class="field full"><label>Nome do cliente</label><input class="input" name="name" required maxlength="120"></div><div class="field"><label>Prefixo dos cards</label><input class="input" name="cardPrefix" required minlength="2" maxlength="12" placeholder="ALPHA"></div><div class="field"><label>Nome do board</label><input class="input" name="boardName" value="Operação" required></div></div>`,
    async (data) => {
      const created = await api("/api/clients", {
        method: "POST",
        body: JSON.stringify(data),
      });
      notify("Cliente e board criados.");
      navigate("/boards/" + created.boardId);
    },
  );
}
async function boards() {
  const d = await api("/api/boards");
  if (d.boards.length === 1) return navigate("/boards/" + d.boards[0].id);
  root.innerHTML = shell(
    "Boards",
    `<div class="panel">${d.boards.map((b: Any) => `<a class="client-row" href="/boards/${b.id}" data-nav><div><strong>${esc(b.name)}</strong><small>${esc(b.client_name)}</small></div><span>→</span></a>`).join("") || '<div class="empty"><strong>Nenhum board</strong>Crie um cliente para gerar o board principal.</div>'}</div>`,
  );
}
async function board(id: string) {
  const [d, catalog] = await Promise.all([
    api("/api/boards/" + id),
    state.catalog ? Promise.resolve(state.catalog) : api("/api/catalog"),
  ]);
  state.board = d;
  state.catalog = catalog;
  if (!state.mobileStage) state.mobileStage = d.stages[0]?.id;
  const f = state.filters,
    today = new Date().toISOString().slice(0, 10);
  const filtered = d.cards.filter(
    (c: Any) =>
      (!f.q ||
        (c.title + c.human_id).toLowerCase().includes(f.q.toLowerCase())) &&
      (!f.assignee || c.assignee_id === f.assignee) &&
      (!f.priority || c.priority === f.priority),
  );
  const task = (c: Any) =>
    `<article class="task" draggable="true" data-card="${c.id}" tabindex="0"><span class="task-id">${esc(c.human_id)}</span><h3>${esc(c.title)}</h3><div class="task-tags">${c.work_type ? `<span class="tag slate">${esc(c.work_type)}</span>` : ""}${c.tags.map((t: Any) => `<span class="tag ${esc(t.color)}">${esc(t.name)}</span>`).join("")}${c.priority !== "NORMAL" ? `<span class="priority ${c.priority}">${c.priority}</span>` : ""}</div><div class="task-meta"><div class="meta-group"><span class="avatar" style="width:25px;height:25px">${initials(c.assignee_name)}</span><span>${c.comments_count ? "◌ " + c.comments_count : ""} ${c.files_count ? "▱ " + c.files_count : ""} ${c.checklist_total ? "✓ " + c.checklist_done + "/" + c.checklist_total : ""}</span></div><span class="due ${c.due_date && c.due_date < today && c.stage_name !== "Done" ? "overdue" : ""}">${fmtDate(c.due_date)}</span></div></article>`;
  const columns = d.stages
    .map((s: Any) => {
      const cards = filtered.filter((c: Any) => c.stage_id === s.id);
      return `<section class="column ${state.mobileStage === s.id ? "mobile-active" : ""}" data-stage="${s.id}"><header class="column-head"><strong>${esc(s.name)}</strong><span><span class="count">${cards.length}</span> <button class="button icon-button" style="width:30px;height:30px;min-height:30px" data-add="${s.id}" aria-label="Criar card em ${esc(s.name)}">+</button></span></header><div class="card-list" data-drop="${s.id}">${cards.map(task).join("") || '<div class="empty">Nenhum card nesta etapa.</div>'}</div></section>`;
    })
    .join("");
  const toolbar = `<div class="board-toolbar"><input class="search" id="board-search" placeholder="Buscar por título ou ID" value="${esc(f.q)}" aria-label="Buscar cards"><select class="filter" id="filter-assignee"><option value="">Responsável</option>${catalog.users
    .filter((u: Any) => u.status === "ACTIVE")
    .map(
      (u: Any) =>
        `<option value="${u.id}" ${f.assignee === u.id ? "selected" : ""}>${esc(u.name)}</option>`,
    )
    .join(
      "",
    )}</select><select class="filter" id="filter-priority"><option value="">Prioridade</option>${["LOW", "NORMAL", "HIGH", "URGENT"].map((p) => `<option ${f.priority === p ? "selected" : ""}>${p}</option>`).join("")}</select><button class="button ghost" id="clear-filters">Limpar</button></div><div class="mobile-stages">${d.stages.map((s: Any) => `<button class="button ${state.mobileStage === s.id ? "primary" : ""}" data-mobile-stage="${s.id}">${esc(s.name)} · ${filtered.filter((c: Any) => c.stage_id === s.id).length}</button>`).join("")}</div><div class="board">${columns}</div>`;
  root.innerHTML =
    shell(
      `${d.board.client_name} · ${d.board.name}`,
      toolbar,
      `<button class="button primary" data-add="${d.stages[0]?.id}"><span>+ Novo card</span></button>`,
    ) +
    `<button class="button primary fab" data-add="${d.stages[0]?.id}" aria-label="Novo card">+</button>`;
  wireBoard();
  const linked = new URLSearchParams(location.search).get("card");
  if (linked) { history.replaceState({}, "", location.pathname); openCard(linked); }
}
function wireBoard() {
  document.querySelectorAll("[data-card]").forEach((el) => {
    el.addEventListener("click", () =>
      openCard((el as HTMLElement).dataset.card!),
    );
    el.addEventListener("keydown", (e) => {
      if ((e as KeyboardEvent).key === "Enter")
        openCard((el as HTMLElement).dataset.card!);
    });
    el.addEventListener("dragstart", () => el.classList.add("dragging"));
    el.addEventListener("dragend", () => el.classList.remove("dragging"));
  });
  document.querySelectorAll("[data-drop]").forEach((el) => {
    el.addEventListener("dragover", (e) => {
      e.preventDefault();
      el.classList.add("dragover");
    });
    el.addEventListener("dragleave", () => el.classList.remove("dragover"));
    el.addEventListener("drop", async (e) => {
      e.preventDefault();
      const card = document.querySelector(".dragging") as HTMLElement;
      if (card) {
        await moveCard(card.dataset.card!, (el as HTMLElement).dataset.drop!);
      }
    });
  });
  document
    .querySelectorAll("[data-add]")
    .forEach((b) =>
      b.addEventListener("click", () =>
        newCard((b as HTMLElement).dataset.add!),
      ),
    );
  document.querySelectorAll("[data-mobile-stage]").forEach((b) =>
    b.addEventListener("click", () => {
      state.mobileStage = (b as HTMLElement).dataset.mobileStage;
      board(state.board.board.id);
    }),
  );
  const search = document.querySelector<HTMLInputElement>("#board-search")!;
  search.addEventListener("input", () => {
    state.filters.q = search.value;
    board(state.board.board.id);
  });
  document
    .querySelector("#filter-assignee")
    ?.addEventListener("change", (e) => {
      state.filters.assignee = (e.target as HTMLSelectElement).value;
      board(state.board.board.id);
    });
  document
    .querySelector("#filter-priority")
    ?.addEventListener("change", (e) => {
      state.filters.priority = (e.target as HTMLSelectElement).value;
      board(state.board.board.id);
    });
  document.querySelector("#clear-filters")?.addEventListener("click", () => {
    state.filters = { q: "", assignee: "", priority: "" };
    board(state.board.board.id);
  });
}
function newCard(stageId: string) {
  modal(
    "Novo card",
    `<div class="field"><label>Título</label><input class="input" name="title" required maxlength="240"></div><div class="form-grid" style="margin-top:14px"><div class="field"><label>Responsável</label><select class="select" name="assigneeId"><option value="">Sem responsável</option>${state.catalog.users.map((u: Any) => `<option value="${u.id}">${esc(u.name)}</option>`).join("")}</select></div><div class="field"><label>Prazo</label><input class="input" name="dueDate" type="date"></div><div class="field"><label>Prioridade</label><select class="select" name="priority">${["NORMAL", "LOW", "HIGH", "URGENT"].map((p) => `<option>${p}</option>`).join("")}</select></div><div class="field"><label>Formato</label><select class="select" name="workTypeId"><option value="">Sem formato</option>${state.catalog.types
      .filter((t: Any) => t.active)
      .map((t: Any) => `<option value="${t.id}">${esc(t.name)}</option>`)
      .join("")}</select></div></div>`,
    async (data) => {
      data.boardId = state.board.board.id;
      data.stageId = stageId;
      await api("/api/cards", { method: "POST", body: JSON.stringify(data) });
      notify("Card criado.");
      board(state.board.board.id);
    },
  );
}
async function moveCard(cardId: string, stageId: string) {
  try {
    await api(`/api/cards/${cardId}/move`, {
      method: "POST",
      body: JSON.stringify({ stageId }),
    });
    notify("Card movido.");
    await board(state.board.board.id);
  } catch {
    notify("Não foi possível mover o card.", true);
    await board(state.board.board.id);
  }
}
async function openCard(cardId: string, tab = "overview") {
  const openSeq = ++state.cardOpenSeq;
  document
    .querySelectorAll("[data-card-dialog]")
    .forEach((element) => element.remove());
  const d = await api("/api/cards/" + cardId);
  if (openSeq !== state.cardOpenSeq) return;
  const c = d.card,
    stages = state.board?.stages || [];
  history.replaceState({}, "", `/boards/${c.board_id}?card=${c.id}`);
  const tabs = ["overview", "comments", "files", "time", "activity"];
  let body = "";
  if (tab === "overview")
    body = `<div class="form-grid"><div class="field full"><label>Descrição</label><textarea class="textarea" id="card-description">${esc(c.description)}</textarea></div><div class="field"><label>Responsável</label><select class="select" id="card-assignee"><option value="">Sem responsável</option>${state.catalog.users.map((u: Any) => `<option value="${u.id}" ${u.id === c.assignee_id ? "selected" : ""}>${esc(u.name)}</option>`).join("")}</select></div><div class="field"><label>Prioridade</label><select class="select" id="card-priority">${["LOW", "NORMAL", "HIGH", "URGENT"].map((p) => `<option ${p === c.priority ? "selected" : ""}>${p}</option>`).join("")}</select></div><div class="field"><label>Data de início</label><input class="input" id="card-start" type="date" value="${esc(c.start_date)}"></div><div class="field"><label>Prazo</label><input class="input" id="card-due" type="date" value="${esc(c.due_date)}"></div><div class="field"><label>Publicação</label><input class="input" id="card-publish" type="date" value="${esc(c.publish_date)}"></div><div class="field"><label>Formato</label><select class="select" id="card-type"><option value="">Sem formato</option>${state.catalog.types.map((t: Any) => `<option value="${t.id}" ${t.id === c.work_type_id ? "selected" : ""}>${esc(t.name)}</option>`).join("")}</select></div></div><div class="subsection"><h3>Checklist · ${d.checklist.filter((x: Any) => x.completed).length}/${d.checklist.length}</h3>${d.checklist.map((x: Any) => `<label class="check-item"><input type="checkbox" data-check="${x.id}" ${x.completed ? "checked" : ""}><span>${esc(x.text)}</span></label>`).join("")}<form id="add-check" class="actions" style="margin-top:10px"><input class="input" name="text" placeholder="Novo item" required><button class="button">Adicionar</button></form></div><div class="subsection"><h3>Links externos</h3>${d.links.map((x: Any) => `<a class="file-item" href="${esc(x.url)}" target="_blank" rel="noopener"><span>${esc(x.name)}</span><span>↗</span></a>`).join("")}<button class="button" id="add-link">+ Adicionar link</button></div>`;
  if (tab === "overview" && c.source_system === "RUNRUNIT")
    body = `<section class="origin-panel"><span class="eyebrow">Origem</span><strong>Runrun.it #${esc(c.source_task_id)}</strong>${c.source_project_name ? `<small>Projeto: ${esc(c.source_project_name)}</small>` : ""}${c.source_stage_name ? `<small>Etapa original: ${esc(c.source_stage_name)}</small>` : ""}</section>` + body;
  if (tab === "comments")
    body = `<div>${d.comments.map((x: Any) => `<article class="comment"><div class="comment-head"><strong>${esc(x.author_name)}</strong><time>${new Date(x.created_at).toLocaleString("pt-BR")}</time></div><p>${esc(x.content)}</p></article>`).join("") || '<div class="empty">Nenhum comentário.</div>'}</div><form id="add-comment" class="subsection"><div class="field"><label>Adicionar comentário</label><textarea class="textarea" name="content" required maxlength="5000"></textarea></div><button class="button primary" style="margin-top:10px">Comentar</button></form>`;
  if (tab === "files")
    body = `<div>${d.attachments.map((x: Any) => `<div class="file-item"><a href="/api/files/${x.id}" target="_blank"><strong>${esc(x.filename)}</strong><small class="muted"> · ${Math.round(x.size / 1024)} KB</small></a><button class="button danger" data-delete-file="${x.id}">Remover</button></div>`).join("") || '<div class="empty"><strong>Nenhum arquivo</strong>Anexe imagens, vídeos, PDFs ou documentos.</div>'}</div><div class="subsection"><label class="button primary">Selecionar arquivo<input id="file-upload" type="file" hidden></label><p class="muted">Imagens e documentos até 25 MB; MP4 até 250 MB.</p></div>`;
  if (tab === "time")
    body = `<div class="actions"><button class="button primary" id="start-timer">Iniciar timer</button><button class="button" id="manual-time">Adicionar tempo manual</button></div><div class="subsection">${d.timeEntries.map((x: Any) => `<div class="time-row" style="grid-template-columns:1fr auto"><div><strong>${esc(x.user_name)}</strong><small class="muted"> · ${x.source}</small></div><span>${fmtTime(x.duration_seconds || Math.floor((Date.now() - new Date(x.started_at).getTime()) / 1000))}</span></div>`).join("") || '<div class="empty">Nenhum tempo lançado.</div>'}</div>`;
  if (tab === "activity")
    body =
      d.activities
        .map(
          (x: Any) =>
            `<div class="activity-row" style="grid-template-columns:1fr auto"><div><strong>${esc(x.summary)}</strong><small class="muted"> · ${esc(x.actor_name)}</small></div><time class="muted">${new Date(x.created_at).toLocaleString("pt-BR")}</time></div>`,
        )
        .join("") || '<div class="empty">Nenhuma atividade.</div>';
  const wrap = document.createElement("div");
  wrap.dataset.cardDialog = "true";
  wrap.innerHTML = `<div class="drawer-backdrop"></div><aside class="drawer" role="dialog" aria-modal="true" aria-label="Detalhes do card"><header class="drawer-head"><div class="drawer-title"><span class="task-id">${esc(c.human_id)}</span><input id="card-title" value="${esc(c.title)}" aria-label="Título do card"></div><button class="button icon-button" data-close aria-label="Fechar">×</button></header><nav class="drawer-tabs">${tabs.map((t) => `<button data-tab="${t}" class="${tab === t ? "active" : ""}">${({ overview: "Visão geral", comments: `Comentários · ${d.comments.length}`, files: `Arquivos · ${d.attachments.length}`, time: "Tempo", activity: "Atividade" } as Any)[t]}</button>`).join("")}</nav><div class="drawer-body">${body}</div><footer class="drawer-foot"><select class="select" id="move-stage" style="max-width:220px" aria-label="Mover para"><option value="">Mover para...</option>${stages.map((s: Any) => `<option value="${s.id}">${esc(s.name)}</option>`).join("")}</select>${tab === "overview" ? '<button class="button primary" id="save-card">Salvar alterações</button>' : ""}</footer></aside>`;
  document.body.append(wrap);
  const close = () => {
    state.cardOpenSeq++;
    wrap.remove();
    history.replaceState({}, "", `/boards/${c.board_id}`);
  };
  wrap.querySelector("[data-close]")!.addEventListener("click", close);
  wrap.querySelector(".drawer-backdrop")!.addEventListener("click", close);
  wrap.querySelectorAll("[data-tab]").forEach((b) =>
    b.addEventListener("click", () => {
      wrap.remove();
      openCard(cardId, (b as HTMLElement).dataset.tab);
    }),
  );
  wrap.querySelector("#move-stage")?.addEventListener("change", async (e) => {
    const stage = (e.target as HTMLSelectElement).value;
    if (stage) {
      wrap.remove();
      await moveCard(cardId, stage);
    }
  });
  wireCard(wrap, d, tab);
}
function wireCard(wrap: HTMLElement, d: Any, tab: string) {
  const c = d.card;
  wrap.querySelector("#save-card")?.addEventListener("click", async () => {
    try {
      await api(`/api/cards/${c.id}`, {
        method: "PATCH",
        body: JSON.stringify({
          version: c.version,
          title: (wrap.querySelector("#card-title") as HTMLInputElement).value,
          description: (
            wrap.querySelector("#card-description") as HTMLTextAreaElement
          ).value,
          assigneeId: (
            wrap.querySelector("#card-assignee") as HTMLSelectElement
          ).value,
          priority: (wrap.querySelector("#card-priority") as HTMLSelectElement)
            .value,
          workTypeId: (wrap.querySelector("#card-type") as HTMLSelectElement)
            .value,
          startDate: (wrap.querySelector("#card-start") as HTMLInputElement)
            .value,
          dueDate: (wrap.querySelector("#card-due") as HTMLInputElement).value,
          publishDate: (wrap.querySelector("#card-publish") as HTMLInputElement)
            .value,
        }),
      });
      notify("Alterações salvas.");
      wrap.remove();
      await board(c.board_id);
      openCard(c.id);
    } catch (e: any) {
      notify(
        e.message === "VERSION_CONFLICT"
          ? "O card foi alterado por outra pessoa. Recarregue para continuar."
          : "Não foi possível salvar a alteração.",
        true,
      );
    }
  });
  wrap.querySelectorAll("[data-check]").forEach((x) =>
    x.addEventListener("change", async () => {
      await api("/api/checklist/" + (x as HTMLElement).dataset.check, {
        method: "PATCH",
        body: JSON.stringify({ completed: (x as HTMLInputElement).checked }),
      });
      notify("Checklist atualizado.");
    }),
  );
  wrap.querySelector("#add-check")?.addEventListener("submit", async (e) => {
    e.preventDefault();
    await api(`/api/cards/${c.id}/checklist`, {
      method: "POST",
      body: JSON.stringify(
        Object.fromEntries(new FormData(e.target as HTMLFormElement)),
      ),
    });
    wrap.remove();
    openCard(c.id, "overview");
  });
  wrap.querySelector("#add-comment")?.addEventListener("submit", async (e) => {
    e.preventDefault();
    await api(`/api/cards/${c.id}/comments`, {
      method: "POST",
      body: JSON.stringify(
        Object.fromEntries(new FormData(e.target as HTMLFormElement)),
      ),
    });
    wrap.remove();
    openCard(c.id, "comments");
  });
  wrap.querySelector("#add-link")?.addEventListener("click", () =>
    modal(
      "Adicionar link",
      `<div class="field"><label>Nome</label><input class="input" name="name" required></div><div class="field" style="margin-top:12px"><label>URL</label><input class="input" name="url" type="url" required></div>`,
      async (data) => {
        await api(`/api/cards/${c.id}/links`, {
          method: "POST",
          body: JSON.stringify(data),
        });
        wrap.remove();
        openCard(c.id, "overview");
      },
    ),
  );
  wrap.querySelector("#start-timer")?.addEventListener("click", async () => {
    try {
      await api(`/api/cards/${c.id}/time`, {
        method: "POST",
        body: JSON.stringify({ action: "start" }),
      });
      notify("Timer iniciado.");
      wrap.remove();
      render();
    } catch (e: any) {
      notify(
        e.message === "TIMER_ALREADY_ACTIVE"
          ? `Já existe um timer ativo em ${e.data.active.human_id}.`
          : "Não foi possível iniciar o timer.",
        true,
      );
    }
  });
  wrap.querySelector("#manual-time")?.addEventListener("click", () =>
    modal(
      "Adicionar tempo manual",
      `<div class="field"><label>Data</label><input class="input" type="date" name="date" value="${new Date().toISOString().slice(0, 10)}" required></div><div class="field" style="margin-top:12px"><label>Minutos</label><input class="input" type="number" name="minutes" min="1" max="10080" required></div><div class="field" style="margin-top:12px"><label>Observação</label><input class="input" name="note"></div>`,
      async (data) => {
        data.action = "manual";
        data.durationSeconds = Number(data.minutes) * 60;
        await api(`/api/cards/${c.id}/time`, {
          method: "POST",
          body: JSON.stringify(data),
        });
        wrap.remove();
        openCard(c.id, "time");
      },
    ),
  );
  wrap.querySelector("#file-upload")?.addEventListener("change", async (e) => {
    const file = (e.target as HTMLInputElement).files?.[0];
    if (!file) return;
    notify("Enviando arquivo...");
    try {
      await api(`/api/cards/${c.id}/files`, {
        method: "POST",
        headers: {
          "Content-Type": file.type,
          "X-File-Name": encodeURIComponent(file.name),
          "X-File-Size": String(file.size),
        },
        body: file,
      });
      notify("Arquivo enviado.");
      wrap.remove();
      openCard(c.id, "files");
    } catch {
      notify("Não foi possível enviar o arquivo.", true);
    }
  });
  wrap.querySelectorAll("[data-delete-file]").forEach((b) =>
    b.addEventListener("click", async () => {
      if (confirm("Remover este anexo?")) {
        await api("/api/files/" + (b as HTMLElement).dataset.deleteFile, {
          method: "DELETE",
        });
        wrap.remove();
        openCard(c.id, "files");
      }
    }),
  );
}
async function timesheet() {
  const d = await api("/api/time");
  state.timer = d.active;
  root.innerHTML = shell(
    "Timesheet",
    `<div class="section-head" style="margin-top:0"><div><span class="eyebrow">Registros</span><h2>Tempo da equipe</h2></div>${d.active ? `<button class="button danger" id="stop-timer">Parar ${esc(d.active.human_id)}</button>` : ""}</div><div class="panel">${d.entries.map((x: Any) => `<div class="time-row" style="grid-template-columns:1fr 1fr auto"><div><strong>${esc(x.human_id)} · ${esc(x.title)}</strong><small class="muted">${esc(x.client_name)}</small></div><span>${esc(x.user_name)}</span><strong>${fmtTime(x.duration_seconds || Math.floor((Date.now() - new Date(x.started_at).getTime()) / 1000))}</strong></div>`).join("") || '<div class="empty">Nenhum lançamento de tempo.</div>'}</div>`,
  );
  document.querySelector("#stop-timer")?.addEventListener("click", async () => {
    await api("/api/time/stop", { method: "POST", body: "{}" });
    notify("Timer parado.");
    timesheet();
  });
}
async function team() {
  const c = state.catalog || (await api("/api/catalog"));
  state.catalog = c;
  root.innerHTML = shell(
    "Equipe",
    `<div class="panel">${c.users.map((u: Any) => `<div class="client-row"><div class="profile" style="margin:0;padding:0;border:0"><span class="avatar">${initials(u.name)}</span><div><strong>${esc(u.name)}</strong><small>${esc(u.email)}</small></div></div><span class="pill">${esc(u.role)}</span><span>${esc(u.status)}</span></div>`).join("")}</div>`,
    state.user.role === "ADMIN"
      ? '<button class="button primary" id="new-user">+ Usuário</button>'
      : "",
  );
  document.querySelector("#new-user")?.addEventListener("click", () =>
    modal(
      "Novo usuário",
      `<div class="field"><label>Nome</label><input class="input" name="name" required></div><div class="field"><label>E-mail</label><input class="input" type="email" name="email" required></div><div class="field"><label>Senha temporária</label><input class="input" type="password" name="password" minlength="12" required></div><div class="field"><label>Perfil</label><select class="select" name="role"><option>MEMBER</option><option>ADMIN</option></select></div>`,
      async (data) => {
        await api("/api/users", { method: "POST", body: JSON.stringify(data) });
        state.catalog = null;
        notify("Usuário criado.");
        team();
      },
    ),
  );
}
async function settings() {
  const c = state.catalog || (await api("/api/catalog"));
  const p = (await api("/api/notification-preferences")).preferences;
  const preferenceHtml = `<form id="notification-preferences" class="panel preference-panel"><span class="eyebrow">Notificações</span><h2>Preferências pessoais</h2>${[["internal_enabled","Notificações internas"],["email_enabled","E-mail de prazo"],["due_tomorrow","Prazo amanhã"],["due_today","Vence hoje"],["overdue","Atrasado"]].map(([key,label])=>`<label class="preference-row"><span>${label}</span><input type="checkbox" name="${key}" ${p[key]?"checked":""}></label>`).join("")}<button class="button primary" type="submit">Salvar preferências</button></form>`;
  state.catalog = c;
  root.innerHTML = shell(
    "Configurações",
    `<div class="form-grid"><section class="panel" style="padding:18px"><span class="eyebrow">Formatos</span><h2 style="font:500 17px var(--font-head)">Tipos de trabalho</h2><div class="subsection">${c.types.map((x: Any) => `<span class="tag slate" style="margin:3px">${esc(x.name)}</span>`).join("")}</div>${state.user.role === "ADMIN" ? '<button class="button" id="new-type" style="margin-top:16px">+ Formato</button>' : ""}</section><section class="panel" style="padding:18px"><span class="eyebrow">Classificação</span><h2 style="font:500 17px var(--font-head)">Tags</h2><div class="subsection">${c.tags.map((x: Any) => `<span class="tag ${x.color}" style="margin:3px">${esc(x.name)}</span>`).join("") || '<span class="muted">Nenhuma tag.</span>'}</div>${state.user.role === "ADMIN" ? '<button class="button" id="new-tag" style="margin-top:16px">+ Tag</button>' : ""}</section></div><div class="section-head"><div><span class="eyebrow">Sessão</span><h2>Sua conta</h2></div><button class="button danger" id="logout">Sair</button></div>`,
  );
  document.querySelector("#main")?.insertAdjacentHTML("afterbegin", preferenceHtml);
  document.querySelector("#notification-preferences")?.addEventListener("submit", async (event) => {
    event.preventDefault(); const form=event.currentTarget as HTMLFormElement, data:Any={};
    ["internal_enabled","email_enabled","due_tomorrow","due_today","overdue"].forEach(key=>data[key]=(form.elements.namedItem(key) as HTMLInputElement).checked);
    await api("/api/notification-preferences",{method:"PUT",body:JSON.stringify(data)}); notify("Preferências salvas.");
  });
  document.querySelector("#logout")!.addEventListener("click", async () => {
    await api("/api/auth/logout", { method: "POST", body: "{}" });
    location.href = "/";
  });
  document.querySelector("#new-type")?.addEventListener("click", () =>
    modal(
      "Novo formato",
      '<div class="field"><label>Nome</label><input class="input" name="name" required></div>',
      async (data) => {
        await api("/api/types", { method: "POST", body: JSON.stringify(data) });
        state.catalog = null;
        settings();
      },
    ),
  );
  document.querySelector("#new-tag")?.addEventListener("click", () =>
    modal(
      "Nova tag",
      `<div class="field"><label>Nome</label><input class="input" name="name" required></div><div class="field"><label>Cor</label><select class="select" name="color">${c.tagColors.map((x: string) => `<option>${x}</option>`).join("")}</select></div>`,
      async (data) => {
        await api("/api/tags", { method: "POST", body: JSON.stringify(data) });
        state.catalog = null;
        settings();
      },
    ),
  );
}
function message(e: any) {
  return (
    (
      {
        INVALID_PREFIX: "Use um prefixo com 2 a 12 letras ou números.",
        VERSION_CONFLICT: "O registro foi alterado por outra pessoa.",
        TIMER_ALREADY_ACTIVE: "Já existe um timer ativo.",
        UPLOAD_TYPE_OR_SIZE: "Tipo ou tamanho de arquivo não permitido.",
      } as Any
    )[e.message] || "Não foi possível salvar a alteração."
  );
}
async function render() {
  if (!state.user) return login();
  try {
    const path = state.route;
    if (path === "/") await dashboard();
    else if (path === "/clientes" || path.startsWith("/clientes/"))
      await clients();
    else if (path === "/boards") await boards();
    else if (/^\/boards\/[0-9a-f-]{36}$/i.test(path))
      await board(path.split("/").pop()!);
    else if (path === "/timesheet") await timesheet();
    else if (path === "/equipe") await team();
    else if (path === "/configuracoes") await settings();
    else navigate("/");
    document.querySelectorAll("[data-nav]").forEach((a) =>
      a.addEventListener("click", (e) => {
        e.preventDefault();
        navigate((a as HTMLAnchorElement).pathname);
      }),
    );
    document
      .querySelectorAll("[data-new-card]")
      .forEach((b) => b.addEventListener("click", () => navigate("/boards")));
    await bindNotifications();
  } catch (e: any) {
    if (e.status === 401) {
      state.user = null;
      state.csrf = "";
      login();
    } else {
      root.innerHTML = shell(
        "Erro",
        '<div class="empty"><strong>Não foi possível carregar esta área.</strong><button class="button" onclick="location.reload()">Tentar novamente</button></div>',
      );
    }
  }
}
(async () => {
  try {
    const me = await api("/api/me");
    state.user = me.user;
    state.csrf = me.csrf;
  } catch {}
  render();
})();
